import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Alert } from 'antd';
// import { NHFormItem, NHCheckBox } from "xgui-for-react";
import NHFormItem from '../common/NHFormItem';
import NHCheckBox from '../common/NHCheckBox';

// 示例数据
const defaultStudent = [
    { label: '计算机学院', value: 'bmmc' },
    { label: '计算机科学与技术', value: 'zymc' },
    { label: '2018', value: 'nj' },
    { label: '计算机1201班', value: 'bjmc' },
    { label: '20180101001', value: 'xh' },
    { label: '李华', value: 'xm' },
    { label: '180101001', value: 'ksh' },
    { label: '110000xxxxxxx0001', value: 'sfzjh' },
];

// 可选命名字段
const nameFields = [
    { label: '学院名称', value: 'bmmc' },
    { label: '专业名称', value: 'zymc' },
    { label: '班级名称', value: 'bjmc' },
    { label: '年级', value: 'nj' },
    { label: '姓名', value: 'xm' },
    { label: '学号', value: 'xh' },
    { label: '考生号', value: 'ksh' },
    { label: '身份证号', value: 'sfzjh' },
];

// 分类压缩字段
const classifyFields = [
    { label: '学院', value: 'bmmc' },
    { label: '专业', value: 'zymc' },
    { label: '年级', value: 'nj' },
    { label: '班级', value: 'bjmc' }
];

/**
 * 批量下载照片
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2019-06-12 
 * Version: 1.0
 * Modify log:
 */
class Download extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pathName: '',
            exampleName: ''
        }
    }

    /**
     * * 可选命名字段
     * @memberof Download
     */
    onNameFieldsChange = (checkedArray) => {
        if (checkedArray && checkedArray.length > 0) {
            let exampleName = '';
            checkedArray.map(item => {
                defaultStudent.map(obj => {
                    if (item === obj.value) {
                        exampleName += obj.label + "-";
                    }
                    return null;
                });
                return null;
            });
            exampleName = exampleName.substring(0, exampleName.length - 1) + '.jpg';
            this.setState({ exampleName });
        } else {
            this.setState({ exampleName: '' });
        }
    }

    /**
     * * 分文件夹压缩
     * @memberof Download
     */
    onClassifyFieldsChange = (checkedArray) => {
        if (checkedArray && checkedArray.length > 0) {
            let pathName = '';
            defaultStudent.map(obj => {
                checkedArray.map(item => {
                    if (item === obj.value) {
                        pathName += obj.label + "\\";
                    }
                    return null;
                });
                return null;
            });
            const { form } = this.props;
            const { setFieldsValue } = form;

            let afterSort = classifyFields.map(item => {
                return item.value;
            }).filter(item => checkedArray.includes(item.value));
            setFieldsValue({ classifyFields: afterSort });

            this.setState({ pathName });
        } else {
            this.setState({ pathName: '' });
        }
    }

    render() {

        const { form, total = 0 } = this.props;
        const { pathName, exampleName } = this.state;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
                md: { span: 6 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
                md: { span: 18 }
            }
        };

        return (
            <div style={{ width: '100%' }}>
                <Form>
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 14 }}>
                        <Alert style={{ width: '100%' }} message={`当前共有 ${total} 条记录，没有照片的学生下载时将被忽略`} type="info" showIcon />
                    </div>
                    <NHFormItem formItemLayout={formItemLayout} id={"nameFields"} label={"照片命名规则"} required={true} form={form}>
                        <NHCheckBox dataSource={nameFields} gridLayout={true} columnsNum={3} onChange={this.onNameFieldsChange} />
                    </NHFormItem>
                    <NHFormItem formItemLayout={formItemLayout} id={"classifyFields"} label={"分文件夹下载"} form={form}>
                        <NHCheckBox dataSource={classifyFields} gridLayout={false} onChange={this.onClassifyFieldsChange} />
                    </NHFormItem>
                    <NHFormItem formItemLayout={formItemLayout} label={'示例'} form={form}>
                        <div style={{ whiteSpace: 'normal', wordBreak: 'break-all' }}>{pathName}{exampleName}</div>
                    </NHFormItem>
                </Form>
            </div>
        )
    }
}

const DownloadForm = Form.create()(Download);

Download.propTypes = {
    total: PropTypes.number, //下载照片数量
}

export default DownloadForm;


// WEBPACK FOOTER //
// ./components/studentPhotoMng/DownloadForm.js